import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getExpertSchedules,
  createSchedules,
  getSchedulesTemplate,
} from "redux/actions/expertSchedule";

export enum ScheduleStatus {
  Available = 1,
  BookedIndividule = 2,
  BookedGroup = 3,
}
export interface IOneExpertSchedule {
  formated_time: string;
  id: number;
  schedule_id: number;
  status: ScheduleStatus;
  time: string;
  type: number;
  uuid: string;
}
export interface IExpertSchedule {
  schedules: IOneExpertSchedule[];
  loading: boolean;
  template: any;
  selectedSlot?: any;
}
const initial: IExpertSchedule = {
  schedules: [],
  template: null,
  loading: false,
  selectedSlot: {
    schedule_date: '',
    schedule_time: ''
  }
};

export const expertScheduleSlice = createSlice({
  name: "expertSchedule",
  initialState: initial,
  reducers: {
    setSelectedSlot: (state, action: PayloadAction<Array<any>>) => {
      state.selectedSlot = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExpertSchedules.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getExpertSchedules.fulfilled, (state, action) => {
      state.loading = false;
      state.schedules = action.payload;
    });
    builder.addCase(getExpertSchedules.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(createSchedules.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createSchedules.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createSchedules.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getSchedulesTemplate.pending, (state, action) => {
      state.loading = true;
      state.template = null;
    });
    builder.addCase(getSchedulesTemplate.fulfilled, (state, action) => {
      state.loading = false;
      state.template = action.payload;
    });
    builder.addCase(getSchedulesTemplate.rejected, (state, action) => {
      state.loading = false;
      state.template = null;
    });
  },
});

export const { setSelectedSlot } = expertScheduleSlice.actions;

export default expertScheduleSlice.reducer;
